import React from 'react';
import Autosuggest from 'react-autosuggest';
import BrokerService from '@services/BrokerService';

class BrokerAutoSuggest extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      value: '',
      suggestions: [],
    };
  }

  getSuggestionValue = (suggestion) => {
    this.props.selectedBroker(suggestion);
    return suggestion.companyName;
  };

  renderSuggestion = (suggestion) => {
    return <span>{suggestion.companyName}</span>;
  };

  onChange = (event, { newValue, method }) => {
    this.setState({
      value: newValue,
    });
    if (!newValue || newValue == '') {
      this.props.selectedBroker({});
    }
  };

  onSuggestionsFetchRequested = ({ value }) => {
    BrokerService.autoSuggest(value).then((response) => {
      this.setState({ suggestions: response.data.data });
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  componentDidMount = () => {
    this.setState({
      suggestions: [],
      value: this.props.defaultBroker?.companyName ? this.props.defaultBroker.companyName : '',
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.defaultBroker != this.props.defaultBroker) {
      this.setState({
        value: this.props.defaultBroker?.companyName ? this.props.defaultBroker.companyName : '',
      });
    }
  }

  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: 'Search Broker ...',
      value,
      onChange: this.onChange,
    };

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
        ref={this.props.internalRef}
      />
    );
  }
}

export default BrokerAutoSuggest;
